<script setup>
import { computed } from "vue";
import { RadioGroupRoot } from "reka-ui";
import { cn } from "@/shared/lib/utils";

const props = defineProps({
  modelValue: { type: [String, Number, Boolean], default: undefined },
  disabled: { type: Boolean, default: false },
  class: { type: [String, Object, Array], default: undefined },
});

const emit = defineEmits(["update:modelValue", "change"]);

const model = computed({
  get: () => props.modelValue,
  set: (val) => {
    emit("update:modelValue", val);
    emit("change", val);
  },
});
</script>

<template>
  <RadioGroupRoot
    :model-value="model != null ? String(model) : undefined"
    :disabled="disabled"
    :class="cn('grid gap-3', props.class)"
    @update:model-value="model = $event"
  >
    <slot />
  </RadioGroupRoot>
</template>
